import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsCustomersCustomerEditRoute extends Route {
  model() {
    return this.modelFor('settings.customers.customer');
  }
}

export default instrumentRoutePerformance(SettingsCustomersCustomerEditRoute);
